namespace TabAurous.ECommerce {
    export interface OrderProcessingRow {
        TransItemId?: number;
        ECommOrderNo?: string;
        ECommOrderId?: number;
        ECommOrderItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        TransDate?: string;
        CustomerName?: string;
        VoucherNo?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        DeptName?: string;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ProductId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        AvailablePieces?: number;
        AvailableWeight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        Stoneweight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        Purity?: number;
        PureWeight?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        CcNetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        CcGrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        ProductCode?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Lab?: string;
        Hallmark?: string;
        CurrentPosition?: string;
        OrderStatusId?: number;
        TypeDescription?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        KaratId?: number;
        KaratName?: string;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        MetalId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        ProductName?: string;
        TaxCode?: string;
        HSN?: string;
        HasBom?: boolean;
        Parts?: number;
        CostMethodId?: number;
        CalcOnId?: number;
        BOMDetails?: ECommOrderBOMRow[];
        LaborDetails?: ECommOrderLaborRow[];
        Email?: string;
        Mobile?: string;
    }

    export namespace OrderProcessingRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'ECommerce.OrderProcessing';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            ECommOrderNo = "ECommOrderNo",
            ECommOrderId = "ECommOrderId",
            ECommOrderItemId = "ECommOrderItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            TransDate = "TransDate",
            CustomerName = "CustomerName",
            VoucherNo = "VoucherNo",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            DeptName = "DeptName",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ProductId = "ProductId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            AvailablePieces = "AvailablePieces",
            AvailableWeight = "AvailableWeight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            Stoneweight = "Stoneweight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            Purity = "Purity",
            PureWeight = "PureWeight",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            CcNetAmount = "CcNetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            GrossAmount = "GrossAmount",
            CcGrossAmount = "CcGrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            ProductCode = "ProductCode",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Lab = "Lab",
            Hallmark = "Hallmark",
            CurrentPosition = "CurrentPosition",
            OrderStatusId = "OrderStatusId",
            TypeDescription = "TypeDescription",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            KaratId = "KaratId",
            KaratName = "KaratName",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            MetalId = "MetalId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            HSN = "HSN",
            HasBom = "HasBom",
            Parts = "Parts",
            CostMethodId = "CostMethodId",
            CalcOnId = "CalcOnId",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            Email = "Email",
            Mobile = "Mobile"
        }
    }
}
